document.querySelectorAll(".video__button").forEach(button => {
  button.addEventListener("click", () => {
    const parent = button.closest(".video__frame");
    const videoEl = button.parentElement.querySelector(".video__asset");

    parent.classList.add("video__playing");

    // if uploaded video
    if (videoEl.classList.contains("video__asset--uploaded")) {
      videoEl.play();
    }
    // else youtube or vimeo video
    else {
      videoEl.src += "?autoplay=1";
    }
  });
});

// Get video asset duration
function getVideoDuration(el) {
  var duration = Math.round(el.duration);
  duration = formatTime(duration);

  el.parentElement.querySelector(".video__button .video-duration").textContent = duration;
}

function formatTime(time) {
  // Hours, minutes and seconds
  var hrs = ~~(time / 3600);
  var mins = ~~((time % 3600) / 60);
  var secs = ~~time % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  var ret = "";
  if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
}
